import { defineStore } from 'pinia'

const useProvinceStore = defineStore('province', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default useProvinceStore
